var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/instagram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/instagram",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,1 C20.3137085,1 23,3.6862915 23,7 L23,17 C23,20.3137085 20.3137085,23 17,23 L7,23 C3.6862915,23 1,20.3137085 1,17 L1,7 C1,3.6862915 3.6862915,1 7,1 L17,1 Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57709117,9.70878336 C8.54687783,7.78203422 10.642969,6.69441347 12.7766835,7.01081652 C14.9554044,7.33389346 16.6661065,9.04459556 16.9891835,11.2233165 C17.3055865,13.357031 16.2179658,15.4531222 14.2912166,16.4229088 C12.3644675,17.3926955 10.0329942,17.0175298 8.50773217,15.4922678 C6.98247016,13.9670058 6.60730452,11.6355325 7.57709117,9.70878336 Z M12.4833165,8.98918348 C11.2030878,8.79934165 9.94543313,9.4519141 9.36356114,10.6079636 C8.78168914,11.7640131 9.00678853,13.1628971 9.92194574,14.0780543 C10.8371029,14.9932115 12.2359869,15.2183109 13.3920364,14.6364389 C14.5480859,14.0545669 15.2006583,12.7969122 15.0108165,11.5166835 C14.8169704,10.2094509 13.7905491,9.18302964 12.4833165,8.98918348 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.51,5.5 C18.0622847,5.5 18.51,5.94771525 18.51,6.5 C18.51,7.05228475 18.0622847,7.5 17.51,7.5 L17.5,7.5 C16.9477153,7.5 16.5,7.05228475 16.5,6.5 C16.5,5.94771525 16.9477153,5.5 17.5,5.5 L17.51,5.5 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b84a4e401315b5605f86af3a142ae385.svg";
export { ForwardRef as ReactComponent };